import RouteRedirector from './RouteRedirector';

export default RouteRedirector;
